import styled from "styled-components";

const CTA = styled.a({
  backgroundColor: "#0f5522",
  fontSize: "16px",
  lineHeight: "1.28",
  padding: "20px 0px",
  color: "#fff",
  textDecoration: "none",
  width: "200px",
  textAlign: "center",
  "&:hover": {
    backgroundColor: "#0d481d",
  },
});

export default CTA;
